const resource = '/admin/v1/templates';

export default $axios => ({
  list(payload) {
    return $axios.post(`${resource}/search`, payload);
  },
  store(payload) {
    return $axios.post(`${resource}`, payload);
  },
  detail(id) {
    return $axios.get(`${resource}/${id}`);
  },
  update({id, payload}) {
    return $axios.post(`${resource}/${id}`, payload);
  },
  destroy(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
